import { ConfirmModal } from '@safetyhub/ui';

export type CellDeleteChoice = 'row' | 'col';

type CellDeleteModalProps = {
  open: boolean;
  choice: CellDeleteChoice;
  /** 삭제될 행 수(라벨 표시용). */
  rowCount: number;
  /** 삭제될 열 수(라벨 표시용). */
  colCount: number;
  onChoiceChange: (choice: CellDeleteChoice) => void;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Ctrl/⌘+Delete로 선택 셀이 속한 행/열을 삭제할 때 "행 삭제 / 열 삭제"를 묻는 모달.
 * 공용 [[ConfirmModal]] 위에 행/열 라디오를 본문으로 얹은 것 — 오버레이·z-index·Esc·오버레이 클릭
 * 닫기·포커스 트랩은 base가 소유한다.
 *
 * danger 규약에 따라 **취소가 default(자동 포커스)** 라 Enter는 취소다. 이관 전에는 Enter=삭제였는데,
 * 파괴적 동작의 Enter는 오조작으로 되돌릴 수 없어 규약(취소 기본)을 따른다.
 */
export function CellDeleteModal({
  open,
  choice,
  rowCount,
  colCount,
  onChoiceChange,
  onConfirm,
  onCancel,
}: CellDeleteModalProps) {
  return (
    <ConfirmModal
      open={open}
      title="행/열 삭제"
      confirmLabel="삭제"
      danger
      onConfirm={onConfirm}
      onClose={onCancel}
      body={
        <div className="space-y-2">
          <p className="mb-1 text-sm text-gray-500">선택한 셀이 속한 행 또는 열을 삭제합니다.</p>
          <label className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-50">
            <input
              type="radio"
              name="cell-delete-choice"
              checked={choice === 'row'}
              onChange={() => onChoiceChange('row')}
            />
            <span>행 삭제{rowCount > 1 ? ` (${rowCount}개 행)` : ''}</span>
          </label>
          <label className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-50">
            <input
              type="radio"
              name="cell-delete-choice"
              checked={choice === 'col'}
              onChange={() => onChoiceChange('col')}
            />
            <span>열 삭제{colCount > 1 ? ` (${colCount}개 열)` : ''}</span>
          </label>
        </div>
      }
    />
  );
}
